import { IUserApiBody } from '../types';

export const getXmlValue = (str: string, key: string) => {
  return str.substring(
    str.lastIndexOf('<' + key + '>') + ('<' + key + '>').length,
    str.lastIndexOf('</' + key + '>')
  );
};

export const objectToString = (data: IUserApiBody): string => {
  return JSON.stringify(data);
};
